<script>
import inboxReassignmentModal from '@/data/json/inbox/inboxReassignmentModal.json'

export default {
  props: {
    value: {type: Boolean},
    document: {type: Object}, // -> ehem. items muss noch geändert werden in der usage
  },
  data: (vm) => ({
    files: {
      html: 'mdi-language-html5',
      js: 'mdi-nodejs',
      json: 'mdi-code-json',
      md: 'mdi-language-markdown',
      pdf: 'mdi-file-pdf',
      png: 'mdi-file-image',
      txt: 'mdi-file-document-outline',
      xls: 'mdi-file-excel'
    },
    translations: inboxReassignmentModal,
    isVisible: vm.value,
    searchTerm: '',
    filteredList: [],
  }),
  computed: {
    filteredInboxes() {
      if (this.searchTerm) {
        return this.$store.getters.columnizedInboxes.map(inbox => {
          return inbox.filter(innerInbox => {
            //@TODO: filter children as well if present
            return innerInbox?.inboxname?.toString()?.toLowerCase()?.includes(this.searchTerm?.toString()?.toLowerCase())
          })
        }).filter(inbox => inbox.length > 0)
      } else {
        return this.$store.getters.columnizedInboxes
      }
    },
    dialogWidth() {
      if (this.$store.getters.columnizedInboxes.length >= 1 && this.$store.getters.columnizedInboxes.length <= 6) {
        return '40%'
      } else if (this.$store.getters.columnizedInboxes.length >= 7 && this.$store.getters.columnizedInboxes.length <= 12) {
        return '60%'
      } else {
        return '80%'
      }
    }
  },
  methods: {
    ok(document) {
      this.$emit('input', false)
      this.$emit('ok', {document: document, inbox: this.$store.getters.selectedInbox})
    },
    cancel() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
  }
}
</script>
<template>
  <v-dialog v-model="isVisible" :width="dialogWidth" scrollable @click:outside="cancel" @keydown.esc="cancel">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>{{ $t('component.inbox.change') }}</v-col>
          <v-col align="end" class="mb-0 pb-0" md="3">
            <v-text-field
              :id="'inbox-dialog-filter-' + document.id"
              v-model="searchTerm"
              :label="$t('global.search.term')"
              outlined
              dense
              autofocus
              clearable
              hide-details></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <small>{{ $t('global.document') }} #{{ document && document.workItemId }}</small>
      </v-card-subtitle>

      <v-divider></v-divider>

      <v-card-text class="mt-3">
        <div v-if="$store.getters.selectedInbox.hasOwnProperty('inboxname') && $store.getters.selectedInbox.inboxname !== document.inboxname">
          {{ $t('component.inbox.move.to.destination', {
          currentInbox: document.inboxname,
          selectedInbox: $store.getters.selectedInbox.inboxname
        }) }}
        </div>
        <div v-else>
          <div v-if="filteredInboxes.length !== 0">
            {{ $t('component.inbox.select.destination') }}
          </div>
        </div>

        <v-row dense class="mt-3 mb-3">
          <v-col
            v-for="(column, columnIndex) in filteredInboxes" :key="`col-${columnIndex}`"
            :cols="12 / filteredInboxes.length">
            <div v-for="(col, colIndex) in column" :key="colIndex">
              <v-treeview
                :items="[...col]"
                activatable
                selection-type="independent"
                dense
                active-class="isActive"
                return-object
                item-key="id"
                @update:active.passive="e =>$store.commit('SET_SELECTED_INBOX', e[0])">
                <template #prepend="{ item, open }">
                  <v-icon v-if="!item.file">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
                <template #label="{item}">
                  <span
                    :class="$store.getters.selectedInbox.id === item.id ? 'isActive' : ''">{{ item.inboxname }}</span>
                </template>
              </v-treeview>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="d-flex">
        <v-btn class="flex-grow-1" color="secondary" @click="cancel">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn
          class="flex-grow-1"
          color="primary"
          :disabled="$store.getters.selectedInbox.inboxname === document.inboxname" @click="ok(document)">
          {{ $t('button.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.isActive {
  font-weight: 800;
}
</style>
